import { useEffect, useState } from "react";
import { RefreshCw } from "lucide-react";

// Script principale caricato ora (es. /static/js/main.abc123.js): se in index.html cambia, c'è una versione nuova.
const corrente = () => [...document.scripts].map((s) => s.src).find((s) => /\/static\/js\/main\.[^/]+\.js/.test(s)) || null;

async function aggiorna() {
  try {
    const regs = await navigator.serviceWorker?.getRegistrations?.();
    await Promise.all((regs || []).map((r) => r.update().catch(() => {})));
    const keys = await caches?.keys?.();
    await Promise.all((keys || []).map((k) => caches.delete(k)));
  } catch (_) { /* ricarica comunque */ }
  window.location.reload();
}

export function NuovaVersione() {
  const [nuova, setNuova] = useState(false);
  useEffect(() => {
    const mio = corrente();
    if (!mio) return undefined;
    const nome = new URL(mio).pathname;
    const check = async () => {
      try {
        const html = await (await fetch(`/index.html?v=${Date.now()}`, { cache: "no-store" })).text();
        const m = html.match(/\/static\/js\/main\.[^"']+\.js/);
        if (m && m[0] !== nome) setNuova(true);
      } catch (_) { /* offline */ }
    };
    check();
    const t = setInterval(check, 120000);
    const vis = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", vis);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", vis); };
  }, []);
  if (!nuova) return null;
  return (
    <div data-testid="nuova-versione" className="mb-4 rounded-2xl bg-[#2B2B2B] text-white px-4 py-3 flex items-center gap-3 flex-wrap">
      <RefreshCw size={16} className="text-[#FC82ED]" />
      <span className="text-sm font-semibold flex-1">Nuova versione disponibile</span>
      <button data-testid="nuova-versione-aggiorna" onClick={aggiorna} className="px-4 py-1.5 rounded-full bg-[#FC82ED] text-[#2B2B2B] text-sm font-bold">Aggiorna</button>
    </div>
  );
}
